<div class="container-fluid ">
  <div class="row">
    <div class="col-md-4">
      <div class="user-header py-3">
        <h1 class="font-weight-bold">{{ userData?.Data?.FirstName }} {{ userData?.Data?.LastName }}</h1>
        <div class="user-info">
          <div class="font-weight-bold">{{ userData?.Data?.ApartmentBuilding }}</div>
          <div class="font-weight-bold">{{ user.colony }}, {{ userData?.Data.ZipCode }} – {{ user.city }}, {{ user.state }}</div>
          <div class="badges">
            <span class="badge pl-0">{{_apolusService.literals.RateTitle}}: {{ userData?.Data?.RateDescription }}</span>
            <span class="badge">{{_gearAppService.GearCommonLiterals.Sector}}: {{ userData?.Data?.SectorDescription }}</span>
            <span class="badge">{{_appService.CoreCommonLiterals.Average}}: {{ user.average }} m³/día</span>
            <div class="position-relative d-inline-block" dropdown>
              <a id="btn-step-type-list"  dropdownToggle class="btn badge mr-2 ng-star-inserted pl-0"> {{_appService.CoreCommonLiterals.DiscreteSensorState}}: <span [style.color]="user.stateValve === 'Abierta' ? '#28ca65' : user.stateValve === 'Cerrada' ? 'red' : 'orange'"> {{ user.stateValve }}</span> <i class="fa fa-caret-down ml-1"></i></a>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-left item-list shadow mt-3" role="menu">
                <li role="menuitem" *ngIf="user.stateValve !== 'Abierta'">
                  <a type="button" class="dropdown-item" (click)="updateValveState('Abierta')">{{_appService.CoreCommonLiterals.ValveOpen}}</a>
                </li>
                <li role="menuitem" *ngIf="user.stateValve !== 'Cerrada'">
                  <a type="button" class="dropdown-item" (click)="updateValveState('Cerrada')">{{_appService.CoreCommonLiterals.ValveClosed}}</a>
                </li>
                <li role="menuitem" *ngIf="user.stateValve !== 'Parcial'">
                  <a type="button" class="dropdown-item" (click)="updateValveState('Parcial')">Parcial</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="consumption-area h-100 text-center d-flex flex-column justify-content-center align-items-center">
        <h5 class="text-center text-muted">Consumo del mes actual</h5>
        <div class="consumption-item">
          <h1 class="text-center font-weight-bold">3,150 m³</h1>
        </div>
        <span class="text-center text-muted">{{ currentDate }} a día de hoy</span>
      </div>
    </div>
    <div class="col-md-4 py-3">
      <div class="filters-section">
        <div class="form-row align-items-center justify-content-xl-end">
          <div class="search-bar col-5 d-flex align-items-center">
            <div class="form-group w-100">
              <label for="search-text">{{_apolusService.literals.UserNumber}}</label>
              <i class="fa fa-search"></i>
              <input id="search-text" type="text" class="form-control"
                [placeholder]="_appService.CoreCommonLiterals.ButtonSearch" 
                [(ngModel)]="searchText" 
                name="searchText"
                (input)="search($event)" 
                #inputElement 
                customFocus>
              <span class="input-group-append" *ngIf="searchText">
                <button id="table-preferences" class="btn btn-default btn-secondary" type="button" (click)="searchText = ''; search($event)"><i class="fa fa-times"></i></button>
              </span>
            </div>
          </div>
          <div class="col-5" style="min-width: 200px;">
            <div class="form-group" [tooltip]="_apolusService.literals.ContractNumber">
              <label for="contracNumber">{{_apolusService.literals.ContractNumber}}</label>
              <custom-select *ngIf="contracNumberList"
                [keepValueIfExistsInNewList]="false"
                [filterEnabled]="true"
                [(ngModel)]="contracNumber"
                [bordered]="true"
                name="contracNumber"
                [sourceList]="contracNumberList"
                id="contracNumber"
                (select)="applyFilters()"
              >
              </custom-select>
            </div>
          </div>
          <div class="col-1 col-md-auto text-right mr-2 mr-md-0 btn-sidebar">
            <span class="d-inline-block" tabindex="0" [tooltip]="_appService.CoreCommonLiterals?.Filter" container="body">
              <button type="button" class="btn btn-primary mt-2"
                (click)="sidebar.open(); toggleFiltersSidebar();"
                id="dashboard-btn-filter">
                <i class="fas fa-filter"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-5 h-100">
      <div class="col-md-3 widget-card mt-3">
        <h5 class="text-center">Apolus - Aclus V1</h5>
        <cmp-html-container [id]="'events'" [data]="deviceModelImage" [statusZoom]="false"></cmp-html-container>
      </div>
  
      <div class="col-md-9 widget-card mt-3">
        <h5 class="text-center"></h5>
        <cmp-html-container [id]="'history-consumption'" [data]="userData.HistoryConsumption" [statusZoom]="false"></cmp-html-container>
      </div>
      <div class="col-12 widget-card mt-5" [ngClass]="{'sidebar-open': isSidebarOpen}">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="font-weight-bold mb-0"></h5>
        </div>
        <app-xy-chart 
        [data]="userData.RecentConsumption" 
        [height]="400"
        [isShared]="false"
        [legendPosition]="'top'"
        [granularity]="'hour'"
        ></app-xy-chart>
      </div>
      
      <div class="col-12 widget-card mt-5" >
        <h5 class="font-weight-bold"></h5>
        <cnm-alarm-history-table [datos]="historyTableData" [height]="400"></cnm-alarm-history-table>
      </div>

  </div>
</div>

<lib-sidebar #sidebar id="dashboard-filters" [title]="_appService.CoreCommonLiterals?.Filter" (onSubmit)="applyFilters();sidebar.close()" (onClose)="toggleFiltersSidebar()">
  <div class="form-group">
    <lib-datepicker 
      [labelText]="_appService.CoreCommonLiterals.RelativeDateFrom"
      [useTime]="true"
      name="dateFrom"
      id="dateFrom"
      [(ngModel)]="dateFrom"
      [disabledFutureDates]="true"
    ></lib-datepicker>
  </div>

  <div class="form-group">
    <lib-datepicker 
      [labelText]="_appService.CoreCommonLiterals.RelativeDateTo"
      [useTime]="true"
      name="dateTo"
      id="dateTo"
      [(ngModel)]="dateTo"
      [defaultToday]="true"
      [disabledFutureDates]="true"
      [initCurrentTime]="true"
    ></lib-datepicker>
  </div>
  <button type="submit" id="btn-applyfilters" class="btn btn-primary btn-block mt-3" (click)="applyFilters(); sidebar.close()" [disabled]="loading">
    <span *ngIf="!loading">{{_appService.CoreCommonLiterals?.Apply}}</span>
    <i *ngIf="loading" class="fas fa-circle-notch fa-spin fa-1x fa-fw"></i>
  </button>
</lib-sidebar>

